import React from 'react';
import styled from '@emotion/styled';

import { GetPdpIntegratedData_pdp_base_info_epick_list as Epick } from '@domains/pdp-common';

import { EpickStylistItemCard } from './ItemCard';

interface Props {
  isApp: boolean;
  list: Epick[];
  onClickItemCard: (post_id: string, landing_url: string) => void;
  onImpressionItemCard: (post_id: string) => void;
}

export const EpickStylistCarousel: React.FC<React.PropsWithChildren<Props>> = ({ isApp, list, onClickItemCard, onImpressionItemCard }) => {
  return (
    <List>
      {list.map(({ id, image_url, landing_url, nickname }) => {
        return (
          <EpickStylistItemCard
            key={id}
            isApp={isApp}
            src={image_url}
            text={nickname}
            onClickItemCard={() => onClickItemCard(id, landing_url)}
            onImpressionItemCard={() => onImpressionItemCard(id)}
          />
        );
      })}
    </List>
  );
};

const List = styled.div`
  margin: 0 -16px;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: scroll;

  & > div:nth-of-type(n + 2) {
    margin: 0 0 0 2px;
  }

  &::before,
  &::after {
    content: '';
    height: 100px;
    flex: 0 0 16px;
  }

  &::-webkit-scrollbar {
    display: none;
    -webkit-appearance: none;
  }
`;
